import { createContext } from "react";

interface IProExportContext {
  wide?: boolean;
}

export const ProExportContext = createContext<IProExportContext>({
  wide: false,
});
